import React, { useEffect, useRef, useState } from 'react'
import {Box, Grid, GridItem, Heading, IconButton, Image, Input, Spacer, Text} from '@chakra-ui/react'
import { Document, Page } from 'react-pdf';
import NavBar from '../../../elements/NavBar'
import { getItem, removeAll, removeItem } from '../../../../utilities/authUtils'
import {useHistory} from 'react-router-dom'
import * as routesNames from '../../../../constants/routes'
import CustomButton from '../../../elements/customButton'
import Loader from '../../../elements/loader'
import { connect, useSelector } from 'react-redux'
import { ActionCreators } from '../../../../redux/actions'
import { bindActionCreators } from 'redux'
import { ViewIcon } from '@chakra-ui/icons';
import OpenFileDialogAdmin from '../../../elements/OpenFileDialogAdmin';
import OpenFIleDialog from '../../../elements/OpenFIleDialog';
import CustomToast from '../../../elements/customToast';
import InvestorDocumentCard from './components/InvestorDocumentCard';
import { detectFileType } from '../../../../utilities/DownloadDocuments';
import { uploadCKYCDocument } from '../../../../services/masterServices';
import ApproveDialog from './components/ApproveDialog';
import DownloadIcon from '../../../../assets/images/download.png'

const VerifyInvestor = (props) => {

    const history = useHistory()
    const CKYCRef = useRef()
    const { addToast } = CustomToast()
    const documentRef = useRef({})
    const USERID = getItem('investorId')
    const adminState = useSelector((state) => state.adminState)
    const [userData, setUserData] = useState(null)
    const [rejectedData, setRejectedData] = useState(null)
    const [inputValues, setInputValues] = useState({})
    const [openModal, setOpenModal] = useState(false)
    const [imageopen, setImageopen] = useState(false)
    const [modalData, setModalData] = useState(null)
    const [currentFileType, setCurrentFileType] = useState(null)
    const [type, setType] = useState('v2_pan')
    const [CKYCData, setCKYCData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [filterUserData, setFilterUserData] = useState(null)
    const userDataProfile = adminState?.getUserByToken?.data?.data
    // const filteredUserData = userData?.checklist_master?.filter((item) => item.version === 2 && (item.title === 'PAN Card' || item.title === 'Aadhaar Card')).slice(0,2)

    let userByIdData = {
        user_id: USERID,
        type: 'pre-sanction'
    }

    useEffect(() => {
        props?.actions?.getUserDetailsByIdAction(userByIdData)
        props.actions.getUserByTokenAction()
    }, [])

    useEffect(() => {
        if (adminState?.getUserDetailsById?.data?.success === true) 
            setUserData(adminState?.getUserDetailsById?.data);
            const rejectData = (adminState?.getUserDetailsById?.data?.data?.user_document_checked_data?.document && JSON.parse(adminState?.getUserDetailsById?.data?.data?.user_document_checked_data?.document))
            console.log("rejectrejectedDataData",rejectData)
              
             setRejectedData(rejectData)
        const employmentType = adminState?.getUserDetailsById?.data?.data?.employment_type;
        const hasUdyamCertificate = adminState?.getUserDetailsById?.data?.data?.document_data?.udyam_certificate !== "";
        const hasGstCertificate = adminState?.getUserDetailsById?.data?.data?.document_data?.gst_registration_certificate !== "";
        const checklist = adminState?.getUserDetailsById?.data?.checklist_master;
    
        if (employmentType === '1' || employmentType === '2' || employmentType === '3') {
            const filterItem = checklist?.filter(item => 
                item.version === 2 && 
                (item.title === 'PAN Card' || item.title === 'Aadhaar Card'|| item.title === 'Current Address Proof')
            ).slice(0, 2);
            setFilterUserData(filterItem);
        } else if (employmentType === '4') {
            const filterItem = checklist?.filter(item => 
                item.version === 2 && 
                !['additional_address_proof', 'partnership_deed', 'udyam_certificate','reg_act_certificate'].includes(item.upload_field_name)
            );
            setFilterUserData(filterItem);
        }
        else if (employmentType === '5') {
            const excludedFields = [
                'rbi_licence_copy',
                'partnership_deed',
                'reg_act_certificate',
            ];
    
            if (!hasUdyamCertificate) {
                excludedFields.push('udyam_certificate');
            }
            const filterItem = checklist?.filter(item => 
                item.version === 2 && 
                !excludedFields.includes(item.upload_field_name)
            );
            setFilterUserData(filterItem);
        }
         else if (employmentType === '6' || employmentType === '7') {
            const excludedFields = [
                'additional_address_proof',
                'rbi_licence_copy',
                'mem_art_association',
                'board_resolution',
                'cob_certificate',
                'incorp_certificate',
            ];
    
            if (!hasGstCertificate  ) {
                excludedFields.push('gst_registration_certificate');
            }
            if (!hasUdyamCertificate) {
                excludedFields.push('udyam_certificate');
            }
            if (employmentType === '6') {
                excludedFields.push('partnership_deed');
            }
    
            const filterItem = checklist?.filter(item => 
                item.version === 2 && 
                !excludedFields.includes(item.upload_field_name)
            );
            setFilterUserData(filterItem);
        }
    }, [adminState?.getUserDetailsById?.data]);
    
    
    useEffect(() => {
        if (adminState?.approveUser?.data?.success === true){
            addToast({ message: adminState?.approveUser?.data?.message, status: 'success' })
            props?.actions?.cleanUpToast()
            removeItem('investorId')
            history.push(routesNames.PRESANCTIONINVESTORS)
        } else if (adminState?.approveUser?.data?.success === false){
            addToast({ message: adminState?.approveUser?.data?.message, status: 'error' })
            props?.actions?.cleanUpToast()
        }
    }, [adminState?.approveUser])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValues({...inputValues, [name]: value})
    }

    const fileType = {
        photo: detectFileType(userData?.data?.photo),
        panCard: detectFileType(userData?.data?.document_data?.pan_card),
        aadhaarFront: detectFileType(userData?.data?.document_data?.aadhaar_front),
        aadhaarBack: detectFileType(userData?.data?.document_data?.aadhaar_back),
        gstCard: detectFileType(userData?.data?.document_data?.gst_registration_certificate),
        boardResolution: detectFileType(userData?.data?.document_data?.board_resolution),
        memArtAssociation: detectFileType(userData?.data?.document_data?.mem_art_association),
        cobCertificate: detectFileType(userData?.data?.document_data?.cob_certificate),
        additionalAddressProof: detectFileType(userData?.data?.document_data?.additional_address_proof),
        rbiLicence: detectFileType(userData?.data?.document_data?.rbi_licence_copy),
        bankStatement: detectFileType(userData?.data?.document_data?.bank_statement_1),
        incorpCertificate: detectFileType(userData?.data?.document_data?.incorp_certificate),
        partnershipDeed: detectFileType(userData?.data?.document_data?.partnership_deed),
        udyamCertificate: detectFileType(userData?.data?.document_data?.udyam_certificate),
        regActCertificate: detectFileType(userData?.data?.document_data?.reg_act_certificate),
        currentAddressProof: detectFileType(userData?.data?.document_data?.current_address_proof),
    }

    const handleModal = (data, fileType) => {
        setOpenModal(!openModal)
        setModalData(data)
        setCurrentFileType(fileType)
    }

    const handleimageOpen = (data, fileType)=>{
        setImageopen(!imageopen)
        setModalData(data)
        setCurrentFileType(fileType)
      }
    const handleSelectDocument = (documentType) => {
        setType(documentType)
    }

    const handleChecked = (documentType, actionType) => {
        documentRef.current[documentType] = actionType
        console.log(documentRef.current, 'actionType')
    }

    const showOpenFileDialog = () => {
        console.log("Opening file dialog");
        CKYCRef.current.click()
    }
    
    const onChangeFile = (e) => {
        console.log("File selected", e.target.files);
        const formData = new FormData()
        formData.append('file', e.target.files[0])
        formData.append('userId', USERID)
        setIsLoading(true)
        uploadCKYCDocument(formData).then((res) => {
            setIsLoading(false)
            if (res?.data?.status === true) {
            addToast({message: res?.data?.message, status: 'success'})
            setCKYCData(res?.data)
            } else if (res?.data?.status === false) {
            addToast({message: res?.data?.message, status: 'error'})
            }
        }).catch((error) => {
            addToast({message: error, status: 'error'})
            setIsLoading(false)
        })
    }

    const handleSubmit = () => {
        const requiredDocuments = Object.keys(documentRef.current)
        let checklist_master = []
        let anyDocumentRejected = false;
        if (requiredDocuments.length === 0) {
            addToast({ message: `Please Check All Documents`, status: 'error' })
            return
        }
        // Check if any document is rejected
        for (let docType of requiredDocuments) {
            if (documentRef.current[docType] === 'reject') {
                anyDocumentRejected = true;
                break;
            }
        }
        // validate all doc types
        let isValidAll = true
        filterUserData?.forEach((item) => {
            if (!documentRef.current[item.upload_field_name]) {
                addToast({ message: `Please Check ${item.upload_field_name.replace('v2_', '').toUpperCase()} Document`, status: 'error' })
                isValidAll = false
            }
        })
        if (!isValidAll) {
            return
        }
        // if (!anyDocumentRejected && !CKYCData?.data?.ckycNumber) {
        //     addToast({ message: `Please Initiate CKYC`, status: 'error' });
        //     return;
        // }
        // if (!anyDocumentRejected && (CKYCData !== null || !inputValues?.acknowledgment)) {
        //     addToast({ message: `Please Initiate CKYC or Enter Acknowledgment Number`, status: 'error' });
        //     return;
        // }
        if (!anyDocumentRejected) {
            if (!CKYCData && !inputValues?.acknowledgment) {
                addToast({ message: `Please Initiate CKYC or Enter Acknowledgment Number`, status: 'error' });
                return;
            }
        }
        for (let docType of requiredDocuments) {
            const commentField = `${docType.replace('v2_', '')}_comment`
            
            if (documentRef.current[docType] === 'reject' && !inputValues[commentField]) {
                addToast({ message: `Please Enter ${docType.replace('v2_', '').toUpperCase()} Reject Comment`, status: 'error' })
                return
            }
            checklist_master.push({
                upload_field_name: docType,
                user_approval_checklist: [
                    {
                        approval_options: documentRef.current[docType] === 'approve' ? "Yes" : "No",
                        comment: inputValues[commentField] || "",
                        reopen_key: (docType === 'v2_pan' || docType === 'v2_aadhar' || docType === 'currentAddressProof' ) ? "personal_details" : '', 
                        reopen_field_name: docType,
                    }
                ]
            })
        }
        let data = {
            checklist_master: checklist_master,
            user_id: Number(USERID),
            ack_number: inputValues?.acknowledgment ?? ''
        }
        // console.log(data, 'Submitted Data');
        props.actions.approveUserAction(data)
    }

    const handleConfirmation = () => {
        setOpenConfirmation(!openConfirmation)
    }

    console.log(inputValues, 'inputValues')

    // const handleLogout = () => {
    //     removeAll()
    //     history.push(routesNames.LOGIN)
    // }

  return (
    <>
        {(adminState?.getUserDetailsById?.loading || adminState?.getUserByToken?.loading || adminState?.approveUser?.loading || isLoading) &&
            <div>
                <Loader />
            </div>
        }
        <Box className='dashboard_box bg_shadow'>
            <Grid className="main_grid_container align-items-center">
                <GridItem colSpan={8}>
                    <Heading as="h2" className='font-poppins page_heading'>Pre Sanction Investors List</Heading>
                </GridItem>
                <GridItem colSpan={4}>
                    <NavBar data={userDataProfile} isAdmin  />
                </GridItem>
            </Grid>
            <Box mt={5}>
                <Grid className="main_grid_container">
                    <GridItem colSpan={7} className='verify_container bg_shadow '>
                        <Box className='d-flex align-items-center justify-content-between'>
                            <Box className='change_profile'>
                                <Box className='change_profile_container user_image_box'>
                                    <Image src={userData?.data?.photo} className="change_profile_image" />
                                    <IconButton onClick={() => handleimageOpen(userData?.data?.photo, fileType.photo)} className="icon_button_view_photo" 
                                    icon={<ViewIcon />} />
                                </Box>
                                <Box className='user_change_profile user_profile_box'>
                                <Heading as="h3" className='font-poppins'>{userData?.data?.first_name}{' '}{userData?.data?.middle_name}{' '}{userData?.data?.last_name}</Heading>
                                    <Heading as="h5" className='font-poppins'>Investor ID: <span>{userData?.data?.id}</span></Heading>
                                    <Heading as="h5" className='font-poppins'>Aadhaar Mobile Number: <span className='digio_active'>{
                                            userData?.data?.personal_data?.aadhar_mobile_number 
                                                ? userData.data.personal_data.aadhar_mobile_number 
                                                : userData?.data?.personal_data?.is_aadhar_mobile_num_same === 1 
                                                ? "Same as Registered  Mobile Number" 
                                                : ""
                                            }</span></Heading>
                                    <Heading as="h5" className='font-poppins'> AI Based Match Verified: <span className='digio_active'>{userData?.data?.personal_data?.is_photo_verified == 1  ? <span className='digio_active'>Matched</span> : <span className='notmatched'>Not Matched</span>}</span></Heading>
                                    <Text className={userData?.data?.digilocker_request?.status === 'approved' ? 'font-poppins digio_active' : 'font-poppins manual_active'}>
                                        {userData?.data?.digilocker_request?.status === 'approved' ? 'Aadhaar Verified Via Digi Locker' : 'Aadhaar Uploaded Manually '}
                                    </Text>
                                    {
                                        userData?.data?.cp_id && 
                                    <Heading as="h5" className='font-poppins'> Channel Partner: {" "}<span>{userData?.data?.cp_name}</span></Heading>
                                    }
                                </Box>
                            </Box>
                            <Box className='user_profile_details'>
                                <Heading as="h6" className='font-poppins'>{userData?.data?.email}</Heading>
                                <Text className='font-poppins'>{userData?.data?.mobile}</Text>
                                <CustomButton size="sm" type="submit" title="Initiate CKYC" className="btn_green font-poppins" onClick={() => showOpenFileDialog()} />
                                <Input
                                    size="md"
                                    name="upload"
                                    type="file"
                                    accept=".zip"
                                    onChange={(e) => onChangeFile(e)}
                                    className="d-none"
                                    ref={CKYCRef}
                                />
                            </Box>
                        </Box>
                        <Grid className="main_grid_container" mt={5}>
                            {filterUserData?.map((item, index) => {
                                return (
                                   <InvestorDocumentCard item={item} key={index} inputValues={inputValues} type={type} userData={userData}
                                        handleChange={handleChange} handleSelectDocument={handleSelectDocument}
                                        handleChecked={handleChecked}
                                        rejectedData={rejectedData}

                                    />
                                )
                            })}
                        </Grid>
                        {
                            userData?.data?.personal_data?.current_address &&
                            <Box className="verify_card_details verify_document_details" mt ={4}>
                            <Box className='d-flex align-items-center justify-content-between document_header'>
                                <Box className='document_name'>
                                    <Box className='document_status' />
                                    <Heading as="h4" className='font-poppins'>Current Address</Heading>
                                </Box>
                            </Box>
                            <Box className='verify_document_details'>
                                <Box className='verify-form-data'>
                                    <Box className='d-flex align-items-center col-gap-10 flex-wrap'>
                                        <Box className='verify_document_data width-48'>
                                            <Text className='font-poppins'>Current Address</Text>
                                            <Heading as="h6" className='font-poppins'>{userData?.data?.personal_data?.current_address}</Heading>
                                        </Box>
                                        <Box className='verify_document_data width-48'>
                                            <Text className='font-poppins'>Pincode</Text>
                                            <Heading as="h6" className='font-poppins'>{userData?.data?.personal_data?.current_pincode}</Heading>
                                        </Box>
                                    </Box>
                                    <Box className='d-flex align-items-center col-gap-10 flex-wrap' mt={3}>
                                        <Box className='verify_document_data width-48'>
                                            <Text className='font-poppins'>House Number:</Text>
                                            <Heading as="h6" className='font-poppins'>{userData?.data?.personal_data?.current_addressline2}</Heading>
                                        </Box>
                                       
                                    </Box>
                                    <Box className='d-flex align-items-center col-gap-10 flex-wrap'>
                                        <Box className='verify_document_data width-48'>
                                            <Text className='font-poppins'>District</Text>
                                            <Heading as="h6" className='font-poppins'>{userData?.data?.personal_data?.current_city}</Heading>
                                        </Box>
                                        <Box className='verify_document_data width-48'>
                                            <Text className='font-poppins'>State</Text>
                                            <Heading as="h6" className='font-poppins'>{userData?.data?.personal_data?.current_state}</Heading>
                                        </Box>
                                    </Box>
                                    <Box className='verify_document_data' mt={3}>
                                        <Text className='font-poppins'>Pincode</Text>
                                        <Heading as="h6" className='font-poppins'>{userData?.data?.personal_data?.address_pincode}</Heading>
                                    </Box>

                                </Box>
                            </Box>
                        </Box>
                          }
                          
                        {CKYCData?.data ?
                            <Grid className="main_grid_container" mt={5}>
                                <GridItem colSpan={6}>
                                    <Box className="verify_card_details">
                                        <Box className='d-flex align-items-center justify-content-between document_header'>
                                            <Box className='document_name'>
                                                <Box className='document_status' />
                                                <Heading as="h4" className='font-poppins'>CKYC</Heading>
                                            </Box>
                                        </Box>
                                        <Box className='verify_document_details'>
                                            <Box className='verify-form-data'>
                                                <Box className='d-flex align-items-center col-gap-10 flex-wrap'>
                                                    <Box className='verify_document_data width-48'>
                                                        <Text className='font-poppins'>CKYC Number:</Text>
                                                        <Heading as="h6" className='font-poppins'>{CKYCData?.data?.ckycNumber}</Heading>
                                                    </Box>
                                                    <Box className='verify_document_data width-48'>
                                                        <Text className='font-poppins'>Father’s Name:</Text>
                                                        <Heading as="h6" className='font-poppins'>{CKYCData?.data?.fatherName}</Heading>
                                                    </Box>
                                                </Box>
                                                <Box className='d-flex align-items-center col-gap-10 flex-wrap' mt={3}>
                                                    <Box className='verify_document_data width-48'>
                                                        <Text className='font-poppins'>Id Proof:</Text>
                                                        <Heading as="h6" className='font-poppins'>{CKYCData?.data?.idProofNumber}</Heading>
                                                    </Box>
                                                    <Box className='verify_document_data width-48'>
                                                        <Text className='font-poppins'>Phone Number:</Text>
                                                        <Heading as="h6" className='font-poppins'>{CKYCData?.data?.phoneNumber}</Heading>
                                                    </Box>
                                                </Box>
                                                <Box className='d-flex align-items-center col-gap-10 flex-wrap'>
                                                    <Box className='verify_document_data width-48'>
                                                        <Text className='font-poppins'>Email</Text>
                                                        <Heading as="h6" className='font-poppins'>{CKYCData?.data?.email ? CKYCData?.data?.email:'--'}</Heading>
                                                    </Box>
                                                    <Box className='verify_document_data width-48'>
                                                        <Text className='font-poppins'>PanCard No./Form60 </Text>
                                                        <Heading as="h6" className='font-poppins'>{CKYCData?.data?.panCard_form60 ? CKYCData?.data?.panCard_form60 : '--'}</Heading>
                                                    </Box>
                                                </Box>
                                                <Box className='verify_document_data' mt={3}>
                                                    <Text className='font-poppins'>Full Name</Text>
                                                    <Heading as="h6" className='font-poppins'>{CKYCData?.data?.completeName ? CKYCData?.data?.completeName :"--"}</Heading>
                                                </Box>
                                                <Box className='verify_document_data' mt={3}>
                                                    <Text className='font-poppins'>Address:</Text>
                                                    <Heading as="h6" className='font-poppins'>{CKYCData?.data?.address1 ? CKYCData?.data?.address1 :'--'}</Heading>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </GridItem>
                            </Grid> :
                            <Grid className="main_grid_container" mt={5}>
                                <GridItem colSpan={6}>
                                    <Box className='no-ckyc-data'>
                                        <Heading className='font-poppins' as="h4">If CKYC id not found</Heading>
                                        <Box mt={1} className='acknowledgment-box'>
                                            <Input type="text" size="md" name="acknowledgment" placeholder="Please Enter Acknowledgment Number"
                                                className="font-poppins" onChange={handleChange} value={inputValues?.acknowledgment ?? ''}
                                            />
                                        </Box>
                                    </Box>
                                </GridItem>
                            </Grid>
                        }
                        {/* {!CKYCData?.data?.ckycNumber &&
                            <Grid className="main_grid_container" mt={5}>
                                <GridItem colSpan={6}>
                                    <Box className='no-ckyc-data'>
                                        <Heading className='font-poppins' as="h4">If CKYC id not found</Heading>
                                        <Box mt={1} className='acknowledgment-box'>
                                            <Input type="text" size="md" name="acknowledgment" placeholder="Please Enter Acknowledgment Number"
                                                className="font-poppins" onChange={handleChange} value={inputValues?.acknowledgment ?? ''}
                                            />
                                        </Box>
                                    </Box>
                                </GridItem>
                            </Grid>
                        } */}
                        {(userData?.data?.employment_type == 6) &&
                            <Box mt ={40}>
                                <Heading  as="h6" className=" label_heading" fontSize="18px" mt={-16}>Business Address</Heading>
                                <Spacer />

                                <Box className='d-flex justify-content-start' mt={3}>
                                    <Box className='d-flex align-items-center col-gap-10 flex-wrap'>
                                        <Box className='verify_document_data width-48'>
                                            <Text className='font-poppins'>Business Address</Text>
                                            <Heading as="h6" className='font-poppins'>{userData?.data?.personal_data?.company_buss_address}</Heading>
                                        </Box>
                                        <Box className='verify_document_data width-48'>
                                            <Text className='font-poppins'>Business Pincode:</Text>
                                            <Heading as="h6" className='font-poppins'>{userData?.data?.personal_data?.company_buss_pincode}</Heading>
                                        </Box>
                                        <Box className='verify_document_data width-48'>
                                            <Text className='font-poppins'>Business State:</Text>
                                            <Heading as="h6" className='font-poppins'>{userData?.data?.personal_data?.company_buss_state}</Heading>
                                        </Box>
                                    </Box>
                
                                </Box>
                            </Box>
                        }   
                        <Box className='d-flex justify-content-end' mt={4}>
                            <CustomButton size="md" type="submit" title="Submit" className="btn_theme font-poppins" onClick={handleConfirmation} />
                        </Box>
                    </GridItem>
                    <GridItem colSpan={5}>
                        <Box className='verify_container bg_shadow'>
                            {type === 'v2_pan' ?
                                <>
                                    {userData?.data?.document_data?.pan_card ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>PAN Card</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.panCard === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.pan_card}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.pan_card} />
                                                }
                                                {userData?.data?.document_data?.pan_card ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.pan_card, fileType.panCard)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.pan_card}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </> :
                            type === 'v2_aadhar' ?
                                <>
                                    {userData?.data?.document_data?.aadhaar_front ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Aadhaar Front</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.aadhaarFront === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.aadhaar_front}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.aadhaar_front} />
                                                }
                                                {userData?.data?.document_data?.aadhaar_front ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.aadhaar_front, fileType.aadhaarFront)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.aadhaar_front}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                    {userData?.data?.document_data?.aadhaar_back ?
                                        <Box className='document_viewer' mt={4}>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Aadhaar Back</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.aadhaarBack === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.aadhaar_back}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.aadhaar_back} />
                                                }
                                                {userData?.data?.document_data?.aadhaar_back ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.aadhaar_back, fileType.aadhaarBack)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.aadhaar_back}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </> :
                            type === 'gst_registration_certificate' ?
                                <>
                                    {userData?.data?.document_data?.gst_registration_certificate ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>GST Certificate</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.gstCard === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.gst_registration_certificate}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.gst_registration_certificate} />
                                                }
                                                {userData?.data?.document_data?.gst_registration_certificate ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.gst_registration_certificate, fileType.gstCard)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.gst_registration_certificate}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </> :
                            type === 'board_resolution' ?
                                <>
                                    {userData?.data?.document_data?.board_resolution ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Board Resolution</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.boardResolution === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.board_resolution}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.board_resolution} />
                                                }
                                                {userData?.data?.document_data?.board_resolution ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.board_resolution, fileType.boardResolution)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.board_resolution}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </> :
                            type === 'mem_art_association' ?
                                <>
                                    {userData?.data?.document_data?.mem_art_association ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Memorandum and Articles of Association</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.memArtAssociation === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.mem_art_association}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.mem_art_association} />
                                                }
                                                {userData?.data?.document_data?.mem_art_association ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.mem_art_association, fileType.memArtAssociation)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.mem_art_association}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </> :
                            type === 'cob_certificate' ?
                                <>
                                    {userData?.data?.document_data?.cob_certificate ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Certification of commencement of the business</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.cobCertificate === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.cob_certificate}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.cob_certificate} />
                                                }
                                                {userData?.data?.document_data?.cob_certificate ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.cob_certificate, fileType.cobCertificate)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.cob_certificate}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </> :
                            type === 'additional_address_proof' ?
                                <>
                                    {userData?.data?.document_data?.additional_address_proof ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Additional Address Proof</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.additionalAddressProof === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.additional_address_proof}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.additional_address_proof} />
                                                }
                                                {userData?.data?.document_data?.additional_address_proof ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.additional_address_proof, fileType.additionalAddressProof)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.additional_address_proof}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </> :
                            type === 'rbi_licence_copy' ?
                                <>
                                    {userData?.data?.document_data?.rbi_licence_copy ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Additional Address Proof</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.rbiLicence === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.rbi_licence_copy}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.rbi_licence_copy} />
                                                }
                                                {userData?.data?.document_data?.rbi_licence_copy ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.rbi_licence_copy, fileType.rbiLicence)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.rbi_licence_copy}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </> :
                            type === 'v2_bank_statement' ?
                                <>
                                    {userData?.data?.document_data?.bank_statement_1 ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Bank Statement</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.bankStatement === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.bank_statement_1}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.bank_statement_1} />
                                                }
                                                {userData?.data?.document_data?.bank_statement_1 ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.bank_statement_1, fileType.bankStatement)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.bank_statement_1}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </> :
                            type === 'incorp_certificate' ?
                                <>
                                    {userData?.data?.document_data?.incorp_certificate ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Certification of Incorporation</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.incorpCertificate === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.incorp_certificate}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.incorp_certificate} />
                                                }
                                                {userData?.data?.document_data?.incorp_certificate ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.incorp_certificate, fileType.incorpCertificate)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.incorp_certificate}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </>  :
                            type === 'partnership_deed' ?
                                <>
                                    {userData?.data?.document_data?.partnership_deed ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Certification of Partnership Deed </Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.partnershipDeed === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.partnership_deed}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.partnership_deed} />
                                                }
                                                {userData?.data?.document_data?.partnership_deed ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.partnership_deed, fileType.partnershipDeed)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.partnership_deed}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </>  :
                                 type === 'reg_act_certificate' ?
                                 <>
                                     {userData?.data?.document_data?.reg_act_certificate ?
                                         <Box className='document_viewer'>
                                             <Heading as="h4" className='font-poppins document_name_heading'>Registeration Certificate </Heading>
                                             <Box className='pdf_read' mt={0}>
                                                 {fileType.regActCertificate === 'pdf' ?
                                                     <Document file={userData?.data?.document_data?.reg_act_certificate}>
                                                         <Page pageNumber={1} />
                                                     </Document>
                                                     : 
                                                     <Image src={userData?.data?.document_data?.reg_act_certificate} />
                                                 }
                                                 {userData?.data?.document_data?.reg_act_certificate ?
                                                     <Box>
                                                         <IconButton onClick={() => handleModal(userData?.data?.document_data?.reg_act_certificate, fileType.regActCertificate)} className="icon_button_view" 
                                                         icon={<ViewIcon />} />
                                                         <a target='_blank' href={userData?.data?.document_data?.reg_act_certificate}>
                                                             <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                         </a>
                                                     </Box> : null
                                                 }
                                             </Box>
                                         </Box> : 
                                         <Box className='pdf_read no-data'>
                                             <Heading as="h6" className='font-poppins'>No document available</Heading>
                                         </Box>
                                     }
                                 </>  :
                            type === 'udyam_certificate' ?
                                  <>
                                    {userData?.data?.document_data?.udyam_certificate ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Certification of Udyam Certificate</Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.udyamCertificate === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.udyam_certificate}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.udyam_certificate} />
                                                }
                                                {userData?.data?.document_data?.udyam_certificate ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.udyam_certificate, fileType.udyamCertificate)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.udyam_certificate}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </>
                                :
                                type === 'current_address_proof' ?
                                <>
                                    {userData?.data?.document_data?.current_address_proof ?
                                        <Box className='document_viewer'>
                                            <Heading as="h4" className='font-poppins document_name_heading'>Current Address Proof </Heading>
                                            <Box className='pdf_read' mt={0}>
                                                {fileType.currentAddressProof === 'pdf' ?
                                                    <Document file={userData?.data?.document_data?.current_address_proof}>
                                                        <Page pageNumber={1} />
                                                    </Document>
                                                    : 
                                                    <Image src={userData?.data?.document_data?.current_address_proof} />
                                                }
                                                {userData?.data?.document_data?.current_address_proof ?
                                                    <Box>
                                                        <IconButton onClick={() => handleModal(userData?.data?.document_data?.current_address_proof, fileType.currentAddressProof)} className="icon_button_view" 
                                                        icon={<ViewIcon />} />
                                                        <a target='_blank' href={userData?.data?.document_data?.current_address_proof}>
                                                            <IconButton className="icon_button_download" icon={<Image src={DownloadIcon} className="download-link" />} />
                                                        </a>
                                                    </Box> : null
                                                }
                                            </Box>
                                        </Box> : 
                                        <Box className='pdf_read no-data'>
                                            <Heading as="h6" className='font-poppins'>No document available</Heading>
                                        </Box>
                                    }
                                </> 
                             :
                            null
                            }
                        </Box>
                    </GridItem>
                </Grid>
            </Box>
        </Box>
        {
            openModal && (
                <OpenFIleDialog handleModal={handleModal} openModal={openModal} fileType={currentFileType} modalData={modalData} />
            )
        }
        {
            imageopen && (
                <OpenFileDialogAdmin  handleimageOpen={handleimageOpen} imageopen={imageopen} fileType={currentFileType} modalData={modalData} />

            )
        }
        <ApproveDialog openConfirmation={openConfirmation} handleConfirmation={handleConfirmation} handleSubmit={handleSubmit} />
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(ActionCreators, dispatch),
})
  
export default connect(null, mapDispatchToProps)(VerifyInvestor)